module.exports = __webpack_public_path__ + "static/media/jetsmart.6ccc2517.svg";